import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "../../SignUp.css";

const locales = ["en", "nl-BE", "fr-FR"];

const LocaleSwitch = ({ locale, onSwitch }) => (
  <div className={styles.locales}>
    {locales.map((newLocale) => (
      <div
        className={cx({ [styles.active]: newLocale === locale })}
        key={newLocale}
        onClick={() => onSwitch(newLocale)}
      >
        {newLocale.substring(0, 2).toUpperCase()}
      </div>
    ))}
  </div>
);

LocaleSwitch.propTypes = {
  locale: PropTypes.string,
  onSwitch: PropTypes.func.isRequired,
};

export default LocaleSwitch;
